import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/images/lock.svg'


const _hoisted_1 = { id: "hc-reassign" }
const _hoisted_2 = {
  key: 0,
  class: "dialog container p-5 d-flex flex-column text-center text-primary loader-section"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "dialog container d-flex flex-column m-0 px-4 py-2" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 pb-1 mb-2 mt-2",
  for: "user-task"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Task")
], -1 /* HOISTED */)
const _hoisted_10 = { class: "col-6 pb-1 mb-2 mt-2" }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 pb-1 mb-2",
  for: "user-task"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Scheduled Date/Time")
], -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_14 = {
  key: 1,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_15 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 pb-1 mb-2",
  for: "user-name"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Client")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "col-6 pb-1 mb-2" }
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 pb-1 mb-2",
  for: "user-name"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Scheduled User/Employee")
], -1 /* HOISTED */)
const _hoisted_20 = {
  key: 0,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_21 = {
  key: 1,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_22 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "New User/Employee", -1 /* HOISTED */)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "col-6 pb-1 mb-2" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_29 = {
  key: 2,
  class: "form-group mt-2"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", { class: "button find-ai-button" }, "Find a Match", -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 3,
  class: "form-group mt-2"
}
const _hoisted_33 = { class: "find-ai-disabled-btn ai-disabled" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Find a Match ")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  key: 2,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-100" }, null, -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 pb-1 mb-2",
  for: "user-new"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reason"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_42 = { class: "col-6 pb-1 mb-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Reason", -1 /* HOISTED */)
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_46 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_47 = {
  key: 0,
  class: "col-6 pb-1 mb-2"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Tracking Reason", -1 /* HOISTED */)
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_51 = {
  key: 0,
  class: "d-flex justify-content-center mb-3"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelectDropdown = _resolveComponent("MultiSelectDropdown")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_SaveNotifyUser = _resolveComponent("SaveNotifyUser")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "full-height": true,
    title: "Reassign Task",
    "application-id": _ctx.visitDetails.Application,
    "show-product-pill": true,
    "show-background": true,
    "use-gray-theme": true
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_5))
          : (_openBlock(), _createElementBlock("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.visitDetails.TaskName), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  (_ctx.visitDetails.StartDateTime)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.formatDateFromDate(_ctx.visitDetails.StartDateTime)) + " " + _toDisplayString(_ctx.formatTime(_ctx.visitDetails.StartDateTime) +
                                    " - " +
                                    _ctx.formatTime(_ctx.visitDetails.EndDateTime)), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.formatDateFromDate(_ctx.visitDetails.StartDate)) + " " + _toDisplayString(_ctx.formatTime(_ctx.visitDetails.StartTime)) + " " + _toDisplayString(_ctx.visitDetails.EndTime ? " - " + _ctx.formatTime(_ctx.visitDetails.EndTime) : ""), 1 /* TEXT */))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.visitDetails.FirstName) + " " + _toDisplayString(_ctx.visitDetails.LastName), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  (!_ctx.visitDetails.UserFirstName && !_ctx.visitDetails.UserLastName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Unassigned "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.visitDetails.UserFirstName) + " " + _toDisplayString(_ctx.visitDetails.UserLastName), 1 /* TEXT */))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`${_ctx.preSelectedEmpId ? 'col-6 pb-1 mb-2' : 'col-6 mb-4'}`),
                    for: "user-new"
                  }, _hoisted_25, 2 /* CLASS */),
                  _createElementVNode("div", _hoisted_26, [
                    (_ctx.preSelectedEmpId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.employeeName.DisplayName), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_MultiSelectDropdown, {
                            class: "text-center mb-2",
                            "selected-items": _ctx.selectedConflictTypes,
                            options: _ctx.conflictTypes,
                            "show-icons": true,
                            disabled: !_ctx.canShowPremium,
                            onSelectedItemsUpdated: _ctx.selectedItemsUpdated,
                            "find-a-match": true
                          }, null, 8 /* PROPS */, ["selected-items", "options", "disabled", "onSelectedItemsUpdated"]),
                          (!_ctx.isEmployeeListLoading)
                            ? (_openBlock(), _createBlock(_component_TypeaheadInput, {
                                key: 0,
                                getData: _ctx.employeeListFilter,
                                value: _ctx.scheduleEmployee,
                                onValueChanged: _ctx.changescheduleEmployee,
                                placeholder: "Type to Select User",
                                "show-all-by-default": true,
                                "open-on-focus": true,
                                "dropdown-menu-class": "custom-menu",
                                class: _normalizeClass(`${!_ctx.v$.visitDetails.EmpId.$error ? '' : 'field-invalid'}`),
                                onBlur: _ctx.v$.visitDetails.EmpId.$touch
                              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "class", "onBlur"]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.v$.visitDetails.EmpId.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "New User/Employee is Required."))
                            : _createCommentVNode("v-if", true),
                          (_ctx.canShowPremium)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("div", {
                                  class: "find-ai-button-section",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFindAMatch()))
                                }, _hoisted_31)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_33, _hoisted_36)), [
                                  [_directive_tooltip, {
                                                title: `Contact Axxess to unlock this <br /> premium Axxess intelligence feature.`,
                                                placement: 'top',
                                                className: 'lock-premium'
                                            }]
                                ])
                              ]))
                        ], 64 /* STABLE_FRAGMENT */)),
                    (_ctx.isEmployeeListLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("select", {
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedType())),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visitDetails.TypeId) = $event)),
                      class: _normalizeClass(`form-select ${!_ctx.v$.visitDetails.TypeId.$error ? '' : 'field-invalid'}`),
                      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.visitDetails.TypeId.$touch && _ctx.v$.visitDetails.TypeId.$touch(...args)))
                    }, [
                      _hoisted_43,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackingTypes, (trackType) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: trackType.Id,
                          key: trackType.Id,
                          class: "text-capitalize"
                        }, _toDisplayString(trackType.Name), 9 /* TEXT, PROPS */, _hoisted_44))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 34 /* CLASS, HYDRATE_EVENTS */), [
                      [_vModelSelect, _ctx.visitDetails.TypeId]
                    ]),
                    (_ctx.v$.visitDetails.TypeId.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Reason Type is required."))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  (_ctx.cpyTrackingReason.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _withDirectives(_createElementVNode("select", {
                          class: _normalizeClass(`form-select ${!_ctx.v$.visitDetails.ReasonId.$error ? '' : 'field-invalid'}`),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visitDetails.ReasonId) = $event)),
                          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.visitDetails.ReasonId.$touch && _ctx.v$.visitDetails.ReasonId.$touch(...args)))
                        }, [
                          _hoisted_48,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cpyTrackingReason, (reason) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: reason.Id,
                              key: reason.Id
                            }, _toDisplayString(reason.Reason), 9 /* TEXT, PROPS */, _hoisted_49))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 34 /* CLASS, HYDRATE_EVENTS */), [
                          [_vModelSelect, _ctx.visitDetails.ReasonId]
                        ]),
                        (_ctx.v$.visitDetails.ReasonId.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Tracking Reason is Required."))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      (_ctx.isSaving)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, _hoisted_54))
                        : (_openBlock(), _createElementBlock("span", _hoisted_55, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-secondary",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancel()))
                            }, " Cancel "),
                            _createElementVNode("button", {
                              class: "btn btn-primary ms-2",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.reassignVisit()))
                            }, "Reassign"),
                            _createVNode(_component_SaveNotifyUser, {
                              "agency-id": _ctx.visitDetails?.AgencyId,
                              "button-name": 'Reassign and Notify Employee',
                              onHandleSaveVisit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.reassignVisit(true)))
                            }, null, 8 /* PROPS */, ["agency-id"])
                          ]))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}